import { render, staticRenderFns } from "./activeRules.vue?vue&type=template&id=08c1c106&scoped=true&"
import script from "./activeRules.vue?vue&type=script&lang=js&"
export * from "./activeRules.vue?vue&type=script&lang=js&"
import style0 from "./activeRules.vue?vue&type=style&index=0&id=08c1c106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1c106",
  null
  
)

export default component.exports